import { Platform, type _Platform } from ":ui/loaders";
import { global } from ":shared/app";
export default function Loader(props: { subtitle?: string; msg: string }) {
  const $whitelabel = global.store.actions.whitelabel.get;

  return (
    <Platform
      {...props}
      title={$whitelabel().info.id}
      class="relative flex flex-col w-full h-full items-center justify-center bg-bg text-brand"
    />
  );
}
